
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import digiGovLogo from "./images/digi-gov-za.png";
import { NotFoundError } from "@nt-portal/server-sdk";
import { ValidationInput, ValidationInputEvent } from "../../components/validation-input";
import { useTranslation } from "../../hooks";
import { useValidationGroup } from "../../hooks/use-validation-group";
import { MessageType, showMessageBox } from "../../redux/message-box.slice";
import { ClientUserService, JwtAuthService } from "../../services";
import ntLogo from "./images/sa-national-treasury-black-text.svg";

export default function ResetPage() {

    const translate = useTranslation();
    const [_errorMessage, setErrorMessage] = useState<string>('');
    const [_password, setPassword] = useState<string>('');
    const [_passwordConfirm, setPasswordConfirm] = useState<string>('');
    const [_isValid, updateValidation, registerValidation] = useValidationGroup()
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        registerValidation([
            { id: "password", isValid: false },
            { id: "password-confirm", isValid: false }
        ]);
    }, [])

    useEffect(() => {
        let service = new JwtAuthService();
        let key = params.id;
        if (key) {
            service.getByResetKey(key).then(result => {
                if (!result) {
                    setErrorMessage(translate("INVALID_RESET_KEY"))
                }
            }).catch(error => {
                if (error instanceof NotFoundError)
                    setErrorMessage(translate("RESET_KEY_NOT_FOUND"))
                else
                    setErrorMessage(error.message)
            });
        } else {
            setErrorMessage(translate("NO_RESET_KEY"))
        }


    }, [params.id])


    const handleChange = (e: ValidationInputEvent) => {
        let confirmMessage = ''
        switch ((e.originalEvent.target as HTMLInputElement).id) {
            case 'password':
                setPassword(e.value);
                if (_passwordConfirm && _passwordConfirm !== e.value) {
                    setErrorMessage(translate("PASSWORDS_DO_NOT_MATCH"))
                } else {
                    setErrorMessage("")
                }
                break;
            case 'password-confirm':
                setPasswordConfirm(e.value);
                if (_password && _password !== e.value) {
                    setErrorMessage(translate("PASSWORDS_DO_NOT_MATCH"))
                } else {
                    setErrorMessage("")
                }
                break;
        }


    }


    const handleValidationChanged = (isValid: boolean, id?: string) => {
        updateValidation(id!, isValid);
    }

    const handlePasswordReset = async () => {
        let service = new ClientUserService();
        let resetKey = params.id;

        if (resetKey) {
            try {
                let result = await service.resetPassword(resetKey, _password);
                if (result) {
                    let message = translate("PASSWORD_RESET", result);
                    dispatch(showMessageBox({ message: message, messageType: MessageType.Success, duration: 2000 }));
                    navigate("/signin")
                }
            } catch (ex) {
                setErrorMessage((ex as Error).message)
            }
        }
    }

    const showInfo = () => {

    }

    return (

        <div id="login-container"
            className="login-container nt-login-shell " >
            <div className="login-container-columns nt-login-columns">
               
                    <div className="nt-login-brand">
                        <div className="nt-login-brand-logo-wrap">
                            <img src={digiGovLogo} alt="DigiGovSA" className="nt-login-brand-logo" />
                        </div>
                        <p className="nt-login-tagline">
                            {translate("CORE_MODERNIZING_SA_GOVERMENT")}
                        </p>
                    </div>
                    
                    <div className="nt-login-nt-logo-wrap">
                        <div className="nt-login-nt-logo-inner">
                            <img src={ntLogo} alt="National Treasury" className="nt-login-nt-logo" />
                        </div>
                    </div>
                    <div className="nt-login-fields nt-login-card" style={{marginTop: "20px"}}>

                        <Tooltip target=".login-password-block">
                            <div dangerouslySetInnerHTML={{ __html: translate("PASSWORD_VALIDATION") }}></div>
                        </Tooltip>


                        <div className="login-field">
                            <ValidationInput required={true} type="password" caption={"PASSWORD"} value={_password}

                                onValidationChanged={handleValidationChanged} onChange={handleChange} id="password" keyName={"password"} />
                        </div>

                        <div className=" login-field">
                            <ValidationInput required={true} type="password" caption={"CONFIRM_PASSWORD"} value={_passwordConfirm}
                                onValidationChanged={handleValidationChanged} onChange={handleChange} id="password-confirm" keyName={"password"} />
                        </div>

                        {_errorMessage ?
                            <div className="card lml-error-login">{_errorMessage}</div> : <></>

                        }


                        <Button label={translate("SUBMIT")} disabled={_errorMessage !== ''} id="password-submit" className='user-login-button nt-login-submit' onClick={handlePasswordReset} />


                    </div>

                </div>


        </div>

    )
}